const checkboxes = {
  size: { default: 16 },

  borderRadius: { default: 4 },

  borderWidth: { default: 2 },
}

export default checkboxes
